import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Car = createSvgIcon(
  <path d="M6.375 3c-.426 0-.816.24-1.006.622L3.427 7.505a.375.375 0 0 1-.244.196L0 8.497v7.219l2.023 3.034h1.169a3.376 3.376 0 0 0 6.366 0h4.884a3.377 3.377 0 0 0 6.366 0H24v-8.625c0-.502-.333-.944-.816-1.082L18.267 7.64 14.74 3.405A1.125 1.125 0 0 0 13.875 3h-7.5Zm8.067 13.5H9.558a3.376 3.376 0 0 0-6.354-.034l-.954-1.432v-4.78l1.479-.37c.226-.057.441-.143.64-.254l3.24 1.62H21.75v5.25h-.942a3.377 3.377 0 0 0-6.366 0ZM16.473 9H8.141L5.784 7.822 7.07 5.25h6.278L16.473 9Z" />,
  'Car'
);

export { Car };